module.exports = __webpack_public_path__ + "static/media/bidding-online-search.27e2e6c6.svg";